import Api from '@/services/Index';

const save = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/ferpa-consent-to-release', data);
}
const getSemesters = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/ferpa-consent-to-release/student-form');
}
export default {
    save,
    getSemesters
}
